export default __webpack_public_path__ + "static/media/handshakeActive.19546bd6.svg";